import { SsuLogoPlaceholder, type Team, type TeamUserInfoDTO } from '@capsicum/common';

export const getWCPledgeTeamFlagUrl = (team: Team | TeamUserInfoDTO) => {
	// If team status is 'Partnered' and has currency with images, use currency images
	if (team.status === 'Partnered' && 'currency' in team && team.currency?.images) {
		const currencyImageUrl = team.currency.images.find(image => image.imageType?.type === 'currency_logo')?.url;

		if (currencyImageUrl) {
			return currencyImageUrl;
		}
	}

	// Otherwise, use the original logic with team.images
	return (
		team.images?.find(image => image.imageType?.type === 'pledge_team_logo')?.url ??
		(SsuLogoPlaceholder as unknown as string)
	);
};
